const en = {
  nav: {
    home: "Home", programs: "Programs", philosophy: "Philosophy", locations: "Locations", gallery: "Gallery",
    book: "Book a Tour", tagline: "Academy · Katy, TX", staff: "Staff login",
  },
  gallery: {
    chapter: "REAL MOMENTS",
    lines: ["Our days, ", "*unfiltered*."],
    sub: "Every photo here was taken at our centers — no stock images. This is what a Tuesday looks like at Learning & Beyond.",
    all: "Both centers",
    count: "{n} photos",
    close: "Close",
    cta: "Want to see it in person?",
    ctaBtn: "Book a tour",
    captions: {
      "clay-playground": "Shaded pre-K playground with our Learn · Play · Grow wall",
      "fry-classroom": "Pre-K classroom, hands-on learning in small groups",
      "clay-foam": "Foam Day! Summer fun under the shade sail",
      "clay-garden": "Our Garden — kids plant, water, and harvest their own vegetables",
      "fry-kitchen": "Home-cooked meals prepared fresh in our kitchen every day",
      "clay-fishing": "Fishing for letters and colors on the playground",
      "fry-exterior": "The N Fry Road Center from the street",
      "clay-reception": "Clay Road front office, where every morning starts with a hello",
      "fry-reception": "N Fry Road reception and our word wall of mantras",
      "fry-splash": "Splash Day on the N Fry Road splash pad",
      "fry-bus": "Our bus — \"Where Kids Soar\" — runs to 13 Katy elementary schools",
      "fry-prek-playground": "Shaded pre-K playground at N Fry Road",
      "fry-toddler-playground": "Toddler playground with sand, water tables, and cozy coupes",
      "fry-afterschool-playground": "The big-kid playground for our after-school crew",
    },
  },
  hours: "Mon – Fri · 6:00 AM – 6:00 PM",
  locations: {
    clay: { name: "Clay Road Center", badge: "Texas Rising Star — Highest 4-Star Rating", alt: "Clay Road Center shaded pre-K playground" },
    fry: { name: "N Fry Road Center", badge: "Modern Early Learning Facility", alt: "N Fry Road Center building exterior" },
    assistanceLabel: "Assistance accepted",
    assistanceShort: { ccs: "TWC CCS scholarships", military: "Military Fee Assistance", tefa: "TEFA (Pre-K)" },
  },
  assistance: {
    chapter: "FINANCIAL ASSISTANCE",
    lines: ["Quality care that", "*fits your budget*."],
    sub: "We proudly accept child care assistance programs at both centers. Not sure if you qualify? Ask us — we'll walk you through applying.",
    both: "Both centers",
    fryOnly: "N Fry Road · Pre-K program",
    items: [
      { key: "ccs", title: "Texas Workforce Commission — Child Care Services (CCS)", body: "Also known as child care scholarships. Both centers are approved CCS providers, so eligible working families can apply their scholarship toward tuition at Clay Road or N Fry Road." },
      { key: "military", title: "Military Fee Assistance Program", body: "Both centers are certified to accept fee assistance for military families through the Military Assistance Program. Bring your approval and we'll take care of the paperwork with you." },
      { key: "tefa", title: "TEFA — Texas Education & Family Assistance", body: "Our N Fry Road Center accepts TEFA for the Pre-K program, helping more families access high-quality pre-kindergarten." },
    ],
    note: "Call either center to check eligibility or to get help with your application.",
  },
  home: {
    eyebrow: "Katy, TX · Ages 6 weeks — 12 years",
    stamps: {
      twc: { top: "We accept", big: "TWC", bottom: "Scholarships!", note: "Both centers" },
      tefa: { top: "Proud", big: "TEFA", bottom: "Participant!", note: "N Fry Road · Pre-K" },
      military: { top: "We accept", big: "Military", bottom: "Assistance Program!", note: "Both centers" },
    },
    heroLines: ["Where little", "learners go", "*beyond*~.~"],
    heroSub: "Two warm, secure childcare centers in Katy serving infants, toddlers, preschoolers, and school-agers — with home-cooked meals and transportation to 13 elementary schools.",
    bookTour: "Book a tour",
    stats: ["6 wks – 12 yrs", "Mon–Fri · 6 AM – 6 PM"],
    trs: "Texas Rising Star 4-Star",
    heroAlt: "Pre-K classroom at Learning & Beyond with children and teacher",
    featChapter: "WHY FAMILIES CHOOSE US",
    featLines: ["Peace of mind,", "built *in*."],
    features: [
      { title: "WatchMeGrow cameras", desc: "Secure live camera access from your phone through WatchMeGrow, so you can peek in on your child's day anytime." },
      { title: "Reggio Emilia-inspired", desc: "Our curriculum follows the Reggio Emilia approach: children lead with their curiosity, teachers guide, and the classroom becomes the third teacher." },
      { title: "Home-cooked meals", desc: "Breakfast, lunch, and snacks prepared fresh in our own kitchens every day." },
      { title: "Texas Rising Star", desc: "Our Clay Rd. center holds the state's highest 4-star quality rating." },
    ],
    locChapter: "01 / TWO HOMES IN KATY",
    locLines: ["Pick the center closest", "to *your family's day*."],
    progChapter: "02 / PROGRAMS",
    progLines: ["Every age has", "its own *orbit*."],
    progMore: "Explore programs",
    programs: [
      { title: "Infants", age: "6 weeks – 12 months", desc: "Nurturing care with daily sensory play, tummy time, and gentle routines that build trust and early development." },
      { title: "Toddlers", age: "1 – 2 years", desc: "Hands-on exploration, first words, and big feelings — guided with patience, structure, and lots of play." },
      { title: "Preschoolers", age: "3 – 5 years", desc: "School-ready curriculum: literacy, math, puzzles, and problem-solving that make learning feel like play." },
      { title: "School Agers", age: "5 – 12 years", desc: "Before/after school care with transportation to 13 Katy elementary schools, homework help, and clubs." },
    ],
    spotChapter: "03 / INSIDE OUR CENTERS",
    spotLines: ["Real spaces, real smiles,", "real *home-cooked meals*."],
    spots: [
      { alt: "Teachers preparing fresh home-cooked meals in the Fry Rd. kitchen", cap: "Fresh, home-cooked meals prepared on-site daily" },
      { alt: "Fry Road front reception with rocket mural and word cloud", cap: "A warm welcome the moment you walk in" },
      { alt: "Clay Road front office reception", cap: "Secure check-in at our Clay Rd. center" },
    ],
    starTitle: "The highest 4-star Texas Rising Star rating — earned at our Clay Rd. center.",
    starBody: "Texas Rising Star is the state's quality rating for early childhood programs. Four stars is its highest level — a promise of quality you can verify.",
    starCta: "Come see it yourself",
    finalLines: ["The best way to choose a", "daycare is to ~walk through~", "the door."],
    finalEnroll: "Start enrollment",
  },
  programs: {
    chapter: "OUR PROGRAMS",
    lines: ["From first steps to", "first day of *sixth grade*."],
    sub: "One center family for your child's whole journey — 6 weeks through 12 years — with a Reggio Emilia-inspired curriculum that builds academic skills, confidence, and character — and WatchMeGrow camera access so you never feel far away.",
    chapters: [
      { title: "Infants", age: "6 weeks – 12 months", points: ["Low ratios and consistent, loving caregivers", "Daily sensory play, music, and tummy time", "Gentle routines for feeding and naps, mirrored from home", "Daily reports so you never miss a moment"] },
      { title: "Toddlers", age: "1 – 2 years", points: ["Hands-on exploration that builds language and motor skills", "First friendships, sharing, and guided social play", "Puzzles, art, and movement woven into every day", "Potty-training partnership when your child is ready"] },
      { title: "Preschoolers", age: "3 – 5 years", points: ["School-readiness curriculum: letters, numbers, shapes, and early writing", "Problem-solving through puzzles, games, and projects", "Curiosity-led learning that makes discovery fun", "Confidence and independence for kindergarten and beyond"] },
      { title: "School Agers", age: "5 – 12 years", points: ["Before and after school care, 6 AM – 6 PM", "Transportation to and from 13 Katy elementary schools", "Homework help, clubs, games, and outdoor play", "A safe, supervised place to land every school day"] },
    ],
    classroomAlt: "Preschool classroom with children learning",
    kitchenAlt: "Home-cooked meals prepared fresh in our kitchen",
    schoolsChapter: "SCHOOL TRANSPORTATION",
    schoolsLines: ["We drive to *13 Katy*", "elementary schools."],
    schoolsSub: "Safe, reliable transportation to and from our centers — and more schools are added as we continue to grow.",
    searchPh: "Search your school...",
    elementary: "Elementary",
    noResults: "Not on our route yet? Call us — we're adding schools as we grow.",
    busAlt: "Learning & Beyond school bus with 'Where Kids Soar' lettering",
    busCap: "Our own bus — \"Where Kids Soar\" — picks up and drops off every school day",
    ctaTitle: "Not sure which program fits? Come see them all in person.",
    ctaBtn: "Book a tour",
  },
  about: {
    chapter: "OUR PHILOSOPHY",
    lines: ["A partnership,", "written in *five*", "*chapters*."],
    sub: "What we believe about children, learning, families, and the promises we make to every community we serve.",
    chapters: [
      { title: "A foundation for school success", body: "Learning & Beyond can help your child enjoy greater success at school. Our curriculum focuses on building your child's academic skills and targets the specific areas that enhance performance in the classroom — cognitive, language, social, emotional, physical, and creative development. As educators, we know children need a solid academic, social, and cognitive foundation to thrive." },
      { title: "Curiosity is the curriculum", body: "We follow the Reggio Emilia approach: your child creates, explores, and problem-solves through hands-on, child-led projects every single day, with teachers as guides and the classroom itself as a \"third teacher.\" This approach recognizes the power of curiosity and the value of passion in making learning a fun, rewarding process. Puzzles and games build cognitive skills — and children become more independent learners, and more confident ones." },
      { title: "Parents are partners", body: "Parent awareness and involvement are strong components of success. We encourage you to be an active participant in our program — we are always available to discuss your child's progress, and we welcome your questions and feedback. Caring for children is a partnership between our teachers, our school, and your family." },
      { title: "Behavior, handled together", body: "We work closely with families to support each child's development — academically, socially, and behaviorally. When concerns arise, our teachers and administrators communicate with parents, discuss what we're seeing, and work together to establish appropriate expectations and strategies for improvement." },
      { title: "Safety is non-negotiable", body: "We have a responsibility to provide a safe, positive, nurturing environment for every child. Parents get secure live camera access through WatchMeGrow, so you can check in on your child anytime. When serious or persistent behavioral issues cannot be resolved through intervention and partnership, we reserve the right to require a child to leave our program. We love our children and respect our families — but safety, accountability, and a positive learning environment are non-negotiable." },
    ],
    quote: "\"Some parents love us because we hold firm boundaries and prioritize safety. Our commitment is to do what is best for the entire community of children in our care.\"",
    sig: "— The Learning & Beyond Team",
    ctaTitle: "Like what we stand for? Let's meet.",
    ctaBtn: "Book a tour",
  },
  locationsPage: {
    chapter: "FIND US",
    lines: ["Two centers.", "One *Katy family*."],
    sub: "Both centers are open Monday through Friday, 6:00 AM to 6:00 PM — built around working families' real schedules.",
    tourBtn: "Tour this center",
    hoursTitle: "Monday – Friday · 6:00 AM – 6:00 PM",
    hoursBody: "Both centers keep the same hours, so drop-off and pick-up stay simple no matter which location your family calls home.",
    mapChapter: "ON THE MAP",
    mapLines: ["Find your", "*quickest drive*."],
    mapTitle: "Map of {loc}",
    directions: "Get directions",
  },
  book: {
    chapter: "VISIT US",
    tourLines: ["Book your", "*tour*."],
    enrollLines: ["Start", "*enrollment*."],
    tourSub: "Pick a center, pick a time — we'll confirm your visit by phone and email. Tours take about 30 minutes.",
    enrollSub: "Tell us about your child and we'll reach out with availability, tuition, and next steps.",
    tabTour: "Book a Tour",
    tabEnroll: "Enrollment",
  },
  form: {
    chooseCenter: "Choose your center",
    parentName: "Parent / guardian name",
    parentPh: "Jane Martinez",
    phone: "Phone",
    phonePh: "(832) 555-0100",
    email: "Email",
    emailPh: "you@example.com",
    preferredDate: "Preferred date",
    preferredTime: "Preferred time",
    ageGroup: "Child's age group",
    notes: "Anything we should know? (optional)",
    notesPh: "Questions, siblings, schedule needs...",
    submitTour: "Request my tour",
    sending: "Sending...",
    childName: "Child's name",
    childPh: "Sofia",
    program: "Program",
    startDate: "Desired start date (optional)",
    message: "Message (optional)",
    messagePh: "Tell us about your child, schedules, or questions...",
    submitEnroll: "Send enrollment inquiry",
    another: "Submit another request",
    tourDoneTitle: "Your tour is requested",
    tourDoneMsg: "We've emailed {loc} and sent a confirmation to {email}. We'll call you shortly to confirm your visit.",
    enrollDoneTitle: "Inquiry received",
    enrollDoneMsg: "We've emailed {loc} about {child}'s enrollment and sent a confirmation to {email}. Our team will reach out with next steps.",
    toastTour: "Tour request sent! Check your email for confirmation.",
    toastEnroll: "Enrollment inquiry sent! Check your email for confirmation.",
    errTour: "Something went wrong. Please call us and we'll book your tour.",
    errEnroll: "Something went wrong. Please call us and we'll help you enroll.",
    ageGroups: ["6 weeks - 12 months (Infant)", "1 - 2 years (Toddler)", "3 - 5 years (Preschool)", "5 - 12 years (School Age)"],
    timeSlots: ["8:00 - 10:00 AM", "10:00 AM - 12:00 PM", "12:00 - 3:00 PM", "3:00 - 5:30 PM"],
    programs: ["Infants (6 weeks - 12 months)", "Toddlers (1 - 2 years)", "Preschool (3 - 5 years)", "Before/After School + Transportation (5 - 12 years)"],
  },
  testimonials: {
    chapter: "04 / FAMILIES SAY",
    lines: ["Don't take our", "word for it, take *theirs*."],
    sub: "Real reviews from real Learning & Beyond families, shared publicly on Google.",
    source: "5-star Google reviews",
    parent: "Parent",
  },
  chat: {
    open: "Chat with Rocket",
    subtitle: "Learning & Beyond helper",
    greeting: "Hi! I'm Rocket, the Learning & Beyond helper. Ask me about our programs, tuition, hours, or the schools we drive to — or I can help you book a tour.",
    placeholder: "Ask me anything...",
    suggestions: ["What does tuition cost?", "Which schools do you drive to?", "Do you accept CCS scholarships?", "What are your hours?", "How do I book a tour?"],
  },
  footer: {
    city: "Katy, Texas",
    blurb: "Childcare for ages 6 weeks to 12 years — building academic, social, and creative foundations so every child can enjoy greater success at school.",
    explore: "Explore",
    copyright: "© 2026 Learning & Beyond Academy · Two centers in Katy, TX",
    trs: "Texas Rising Star 4-Star Rated — Clay Rd. Center",
    privacy: "Privacy Policy",
  },
};

const es = {
  nav: {
    home: "Inicio", programs: "Programas", philosophy: "Filosofía", locations: "Ubicaciones", gallery: "Galería",
    book: "Agendar recorrido", tagline: "Academia · Katy, TX", staff: "Acceso del personal",
  },
  gallery: {
    chapter: "MOMENTOS REALES",
    lines: ["Nuestros días, ", "*sin filtros*."],
    sub: "Cada foto fue tomada en nuestros centros — sin imágenes de archivo. Así se ve un martes cualquiera en Learning & Beyond.",
    all: "Ambos centros",
    count: "{n} fotos",
    close: "Cerrar",
    cta: "¿Quieres verlo en persona?",
    ctaBtn: "Agendar un recorrido",
    captions: {
      "clay-playground": "Patio de pre-kínder con sombra y nuestro muro Learn · Play · Grow",
      "fry-classroom": "Salón de pre-kínder, aprendizaje práctico en grupos pequeños",
      "clay-foam": "¡Día de espuma! Diversión de verano bajo la sombra",
      "clay-garden": "Nuestro huerto — los niños siembran, riegan y cosechan sus propias verduras",
      "fry-kitchen": "Comidas caseras preparadas frescas cada día en nuestra cocina",
      "clay-fishing": "Pescando letras y colores en el patio",
      "fry-exterior": "El Centro N Fry Road visto desde la calle",
      "clay-reception": "Recepción de Clay Road, donde cada mañana empieza con un saludo",
      "fry-reception": "Recepción de N Fry Road y nuestro muro de palabras",
      "fry-splash": "Día de chapoteo en el splash pad de N Fry Road",
      "fry-bus": "Nuestro autobús — \"Where Kids Soar\" — recorre 13 primarias de Katy",
      "fry-prek-playground": "Patio de pre-kínder con sombra en N Fry Road",
      "fry-toddler-playground": "Patio de niños pequeños con arena, mesas de agua y cochecitos",
      "fry-afterschool-playground": "El patio de los grandes para nuestro grupo después de clases",
    },
  },
  hours: "Lun – Vie · 6:00 AM – 6:00 PM",
  locations: {
    clay: { name: "Centro Clay Road", badge: "Texas Rising Star — Máxima calificación de 4 estrellas", alt: "Patio de pre-kínder con sombra del Centro Clay Road" },
    fry: { name: "Centro N Fry Road", badge: "Instalación moderna de aprendizaje temprano", alt: "Exterior del edificio del Centro N Fry Road" },
    assistanceLabel: "Aceptamos asistencia",
    assistanceShort: { ccs: "Becas CCS de TWC", military: "Asistencia militar (Military Fee Assistance)", tefa: "TEFA (Pre-K)" },
  },
  assistance: {
    chapter: "ASISTENCIA FINANCIERA",
    lines: ["Cuidado de calidad que", "*se ajusta a tu presupuesto*."],
    sub: "Con orgullo aceptamos programas de asistencia para el cuidado infantil en ambos centros. ¿No sabes si calificas? Pregúntanos — te guiamos en la solicitud.",
    both: "Ambos centros",
    fryOnly: "N Fry Road · programa Pre-K",
    items: [
      { key: "ccs", title: "Texas Workforce Commission — Child Care Services (CCS)", body: "También conocidas como becas de cuidado infantil (child care scholarships). Ambos centros son proveedores aprobados de CCS, así que las familias trabajadoras elegibles pueden aplicar su beca a la colegiatura en Clay Road o N Fry Road." },
      { key: "military", title: "Military Fee Assistance Program", body: "Ambos centros están certificados para aceptar asistencia de pago para familias militares a través del Military Assistance Program. Trae tu aprobación y nos encargamos del papeleo contigo." },
      { key: "tefa", title: "TEFA — Texas Education & Family Assistance", body: "Nuestro Centro N Fry Road acepta TEFA para el programa de Pre-K, ayudando a más familias a acceder a un pre-kínder de alta calidad." },
    ],
    note: "Llama a cualquiera de los centros para verificar tu elegibilidad o recibir ayuda con tu solicitud.",
  },
  home: {
    eyebrow: "Katy, TX · De 6 semanas a 12 años",
    stamps: {
      twc: { top: "Aceptamos", big: "TWC", bottom: "¡Becas!", note: "Ambos centros" },
      tefa: { top: "Orgullosos", big: "TEFA", bottom: "¡Participantes!", note: "N Fry Road · Pre-K" },
      military: { top: "Aceptamos", big: "Military", bottom: "¡Assistance Program!", note: "Ambos centros" },
    },
    heroLines: ["Donde los pequeños", "llegan más", "*allá*~.~"],
    heroSub: "Dos centros de cuidado infantil cálidos y seguros en Katy para bebés, niños pequeños, preescolares y escolares — con comidas caseras y transporte a 13 escuelas primarias.",
    bookTour: "Agendar un recorrido",
    stats: ["6 sem – 12 años", "Lun–Vie · 6 AM – 6 PM"],
    trs: "Texas Rising Star 4 estrellas",
    heroAlt: "Salón de pre-kínder en Learning & Beyond con niños y maestra",
    featChapter: "POR QUÉ NOS ELIGEN LAS FAMILIAS",
    featLines: ["Tranquilidad,", "*incluida*."],
    features: [
      { title: "Cámaras WatchMeGrow", desc: "Acceso seguro a cámaras en vivo desde tu teléfono con WatchMeGrow, para que veas el día de tu hijo cuando quieras." },
      { title: "Inspirado en Reggio Emilia", desc: "Nuestro currículo sigue el enfoque Reggio Emilia: los niños guían con su curiosidad, las maestras acompañan y el aula es el tercer maestro." },
      { title: "Comidas caseras", desc: "Desayuno, almuerzo y meriendas preparados frescos cada día en nuestras propias cocinas." },
      { title: "Texas Rising Star", desc: "Nuestro centro de Clay Rd. tiene la máxima calificación de calidad de 4 estrellas del estado." },
    ],
    locChapter: "01 / DOS HOGARES EN KATY",
    locLines: ["Elige el centro más cercano", "al *día de tu familia*."],
    progChapter: "02 / PROGRAMAS",
    progLines: ["Cada edad tiene", "su propia *órbita*."],
    progMore: "Ver programas",
    programs: [
      { title: "Bebés", age: "6 semanas – 12 meses", desc: "Cuidado afectuoso con juego sensorial diario, tiempo boca abajo y rutinas suaves que construyen confianza y desarrollo temprano." },
      { title: "Niños pequeños", age: "1 – 2 años", desc: "Exploración práctica, primeras palabras y grandes emociones — guiadas con paciencia, estructura y mucho juego." },
      { title: "Preescolares", age: "3 – 5 años", desc: "Currículo listo para la escuela: lectoescritura, matemáticas, rompecabezas y resolución de problemas que hacen del aprendizaje un juego." },
      { title: "Escolares", age: "5 – 12 años", desc: "Cuidado antes y después de clases con transporte a 13 primarias de Katy, ayuda con tareas y clubes." },
    ],
    spotChapter: "03 / DENTRO DE NUESTROS CENTROS",
    spotLines: ["Espacios reales, sonrisas reales,", "*comidas caseras* de verdad."],
    spots: [
      { alt: "Maestras preparando comidas caseras frescas en la cocina de Fry Rd.", cap: "Comidas caseras frescas preparadas cada día en el centro" },
      { alt: "Recepción de Fry Road con mural de cohete y nube de palabras", cap: "Una cálida bienvenida desde que entras" },
      { alt: "Recepción de la oficina de Clay Road", cap: "Registro seguro en nuestro centro de Clay Rd." },
    ],
    starTitle: "La máxima calificación de 4 estrellas Texas Rising Star — obtenida en nuestro centro de Clay Rd.",
    starBody: "Texas Rising Star es la calificación de calidad del estado para programas de primera infancia. Cuatro estrellas es su nivel más alto — una promesa de calidad que puedes verificar.",
    starCta: "Ven a comprobarlo",
    finalLines: ["La mejor forma de elegir una", "guardería es ~cruzar~", "la puerta."],
    finalEnroll: "Iniciar inscripción",
  },
  programs: {
    chapter: "NUESTROS PROGRAMAS",
    lines: ["De los primeros pasos al", "primer día de *sexto grado*."],
    sub: "Una sola familia de centros para todo el camino de tu hijo — de 6 semanas a 12 años — con un currículo inspirado en Reggio Emilia que construye habilidades académicas, confianza y carácter — y acceso a cámaras WatchMeGrow para que nunca te sientas lejos.",
    chapters: [
      { title: "Bebés", age: "6 semanas – 12 meses", points: ["Grupos pequeños y cuidadoras constantes y cariñosas", "Juego sensorial, música y tiempo boca abajo cada día", "Rutinas suaves de alimentación y siesta, iguales a las de casa", "Reportes diarios para que no te pierdas ni un momento"] },
      { title: "Niños pequeños", age: "1 – 2 años", points: ["Exploración práctica que desarrolla lenguaje y motricidad", "Primeras amistades, compartir y juego social guiado", "Rompecabezas, arte y movimiento en cada jornada", "Apoyo con el entrenamiento para ir al baño cuando tu hijo esté listo"] },
      { title: "Preescolares", age: "3 – 5 años", points: ["Currículo de preparación escolar: letras, números, formas y escritura inicial", "Resolución de problemas con rompecabezas, juegos y proyectos", "Aprendizaje guiado por la curiosidad que hace divertido descubrir", "Confianza e independencia para kínder y más allá"] },
      { title: "Escolares", age: "5 – 12 años", points: ["Cuidado antes y después de clases, 6 AM – 6 PM", "Transporte de ida y vuelta a 13 primarias de Katy", "Ayuda con tareas, clubes, juegos y actividades al aire libre", "Un lugar seguro y supervisado para llegar cada día de escuela"] },
    ],
    classroomAlt: "Salón preescolar con niños aprendiendo",
    kitchenAlt: "Comidas caseras preparadas frescas en nuestra cocina",
    schoolsChapter: "TRANSPORTE ESCOLAR",
    schoolsLines: ["Llevamos a *13 primarias*", "de Katy."],
    schoolsSub: "Transporte seguro y confiable desde y hacia nuestros centros — y agregamos más escuelas conforme crecemos.",
    searchPh: "Busca tu escuela...",
    elementary: "Elementary",
    noResults: "¿Aún no está en nuestra ruta? Llámanos — agregamos escuelas conforme crecemos.",
    busAlt: "Autobús escolar de Learning & Beyond con el letrero 'Where Kids Soar'",
    busCap: "Nuestro propio autobús — \"Where Kids Soar\" — recoge y entrega cada día de escuela",
    ctaTitle: "¿No sabes qué programa se ajusta mejor? Ven a conocerlos en persona.",
    ctaBtn: "Agendar un recorrido",
  },
  about: {
    chapter: "NUESTRA FILOSOFÍA",
    lines: ["Una alianza,", "escrita en *cinco*", "*capítulos*."],
    sub: "Lo que creemos sobre los niños, el aprendizaje, las familias y las promesas que hacemos a cada comunidad que servimos.",
    chapters: [
      { title: "Una base para el éxito escolar", body: "Learning & Beyond puede ayudar a tu hijo a disfrutar de mayor éxito en la escuela. Nuestro currículo se enfoca en construir sus habilidades académicas y en las áreas específicas que mejoran el desempeño en el aula — desarrollo cognitivo, del lenguaje, social, emocional, físico y creativo. Como educadores, sabemos que los niños necesitan una base académica, social y cognitiva sólida para prosperar." },
      { title: "La curiosidad es el currículo", body: "Seguimos el enfoque Reggio Emilia: tu hijo crea, explora y resuelve problemas con proyectos prácticos guiados por su curiosidad todos los días, con las maestras como guías y el aula como \"tercer maestro\". Reconocen el poder de la curiosidad y el valor de la pasión para hacer del aprendizaje un proceso divertido y gratificante. Los rompecabezas y juegos desarrollan habilidades cognitivas — y los niños se vuelven aprendices más independientes y seguros." },
      { title: "Los padres son aliados", body: "La conciencia y participación de los padres son componentes clave del éxito. Te animamos a participar activamente en nuestro programa — siempre estamos disponibles para hablar del progreso de tu hijo y recibimos con gusto tus preguntas y comentarios. Cuidar a los niños es una alianza entre nuestras maestras, nuestra escuela y tu familia." },
      { title: "El comportamiento, en equipo", body: "Trabajamos de cerca con las familias para apoyar el desarrollo de cada niño — académico, social y conductual. Cuando surgen preocupaciones, nuestras maestras y administradores se comunican con los padres, comparten lo que observamos y trabajan juntos para establecer expectativas y estrategias de mejora adecuadas." },
      { title: "La seguridad no se negocia", body: "Tenemos la responsabilidad de ofrecer un entorno seguro, positivo y afectuoso para cada niño. Los padres tienen acceso seguro a cámaras en vivo a través de WatchMeGrow, para ver a su hijo en cualquier momento. Cuando problemas de conducta graves o persistentes no pueden resolverse mediante intervención y colaboración, nos reservamos el derecho de pedir que un niño deje el programa. Amamos a nuestros niños y respetamos a nuestras familias — pero la seguridad, la responsabilidad y un ambiente positivo de aprendizaje no se negocian." },
    ],
    quote: "\"Algunos padres nos quieren porque mantenemos límites firmes y priorizamos la seguridad. Nuestro compromiso es hacer lo mejor para toda la comunidad de niños a nuestro cuidado.\"",
    sig: "— El equipo de Learning & Beyond",
    ctaTitle: "¿Te identificas con lo que creemos? Conozcámonos.",
    ctaBtn: "Agendar un recorrido",
  },
  locationsPage: {
    chapter: "ENCUÉNTRANOS",
    lines: ["Dos centros.", "Una sola *familia en Katy*."],
    sub: "Ambos centros abren de lunes a viernes, de 6:00 AM a 6:00 PM — pensados para los horarios reales de las familias que trabajan.",
    tourBtn: "Recorrer este centro",
    hoursTitle: "Lunes – Viernes · 6:00 AM – 6:00 PM",
    hoursBody: "Ambos centros tienen el mismo horario, así que dejar y recoger a tus hijos es sencillo sin importar cuál sea tu centro.",
    mapChapter: "EN EL MAPA",
    mapLines: ["Encuentra tu", "*ruta más rápida*."],
    mapTitle: "Mapa de {loc}",
    directions: "Cómo llegar",
  },
  book: {
    chapter: "VISÍTANOS",
    tourLines: ["Agenda tu", "*recorrido*."],
    enrollLines: ["Inicia la", "*inscripción*."],
    tourSub: "Elige un centro y una hora — confirmaremos tu visita por teléfono y correo. Los recorridos duran unos 30 minutos.",
    enrollSub: "Cuéntanos sobre tu hijo y te contactaremos con disponibilidad, costos y siguientes pasos.",
    tabTour: "Agendar recorrido",
    tabEnroll: "Inscripción",
  },
  form: {
    chooseCenter: "Elige tu centro",
    parentName: "Nombre del padre / tutor",
    parentPh: "Juana Martínez",
    phone: "Teléfono",
    phonePh: "(832) 555-0100",
    email: "Correo electrónico",
    emailPh: "tu@ejemplo.com",
    preferredDate: "Fecha preferida",
    preferredTime: "Hora preferida",
    ageGroup: "Grupo de edad del niño",
    notes: "¿Algo que debamos saber? (opcional)",
    notesPh: "Preguntas, hermanos, necesidades de horario...",
    submitTour: "Solicitar mi recorrido",
    sending: "Enviando...",
    childName: "Nombre del niño",
    childPh: "Sofía",
    program: "Programa",
    startDate: "Fecha de inicio deseada (opcional)",
    message: "Mensaje (opcional)",
    messagePh: "Cuéntanos sobre tu hijo, horarios o preguntas...",
    submitEnroll: "Enviar solicitud de inscripción",
    another: "Enviar otra solicitud",
    tourDoneTitle: "Tu recorrido fue solicitado",
    tourDoneMsg: "Enviamos un correo a {loc} y una confirmación a {email}. Te llamaremos pronto para confirmar tu visita.",
    enrollDoneTitle: "Solicitud recibida",
    enrollDoneMsg: "Enviamos un correo a {loc} sobre la inscripción de {child} y una confirmación a {email}. Nuestro equipo te contactará con los siguientes pasos.",
    toastTour: "¡Solicitud de recorrido enviada! Revisa tu correo para la confirmación.",
    toastEnroll: "¡Solicitud de inscripción enviada! Revisa tu correo para la confirmación.",
    errTour: "Algo salió mal. Llámanos y agendaremos tu recorrido.",
    errEnroll: "Algo salió mal. Llámanos y te ayudaremos a inscribirte.",
    ageGroups: ["6 semanas - 12 meses (Bebé)", "1 - 2 años (Niño pequeño)", "3 - 5 años (Preescolar)", "5 - 12 años (Escolar)"],
    timeSlots: ["8:00 - 10:00 AM", "10:00 AM - 12:00 PM", "12:00 - 3:00 PM", "3:00 - 5:30 PM"],
    programs: ["Bebés (6 semanas - 12 meses)", "Niños pequeños (1 - 2 años)", "Preescolar (3 - 5 años)", "Antes/Después de clases + Transporte (5 - 12 años)"],
  },
  testimonials: {
    chapter: "04 / LAS FAMILIAS DICEN",
    lines: ["No te quedes con nuestra", "palabra, escucha la *suya*."],
    sub: "Reseñas reales de familias de Learning & Beyond, publicadas en Google (en su idioma original).",
    source: "Reseñas de 5 estrellas en Google",
    parent: "Madre / padre",
  },
  chat: {
    open: "Chatea con Rocket",
    subtitle: "Asistente de Learning & Beyond",
    greeting: "¡Hola! Soy Rocket, el asistente de Learning & Beyond. Pregúntame sobre programas, costos, horarios o las escuelas a las que llevamos — o te ayudo a agendar un recorrido.",
    placeholder: "Pregúntame lo que quieras...",
    suggestions: ["¿Cuánto cuesta la colegiatura?", "¿A qué escuelas llevan?", "¿Aceptan becas CCS?", "¿Cuál es el horario?", "¿Cómo agendo un recorrido?"],
  },
  footer: {
    city: "Katy, Texas",
    blurb: "Cuidado infantil de 6 semanas a 12 años — construyendo bases académicas, sociales y creativas para que cada niño disfrute de mayor éxito en la escuela.",
    explore: "Explorar",
    copyright: "© 2026 Learning & Beyond Academy · Dos centros en Katy, TX",
    trs: "Texas Rising Star 4 estrellas — Centro Clay Rd.",
    privacy: "Política de privacidad",
  },
};

export const translations = { en, es };
